import { getApiErrorMessage, type ApiErrorOptions } from "@/lib/error-toast";

export interface FormErrorInlineProps {
  error: unknown;
  fallback?: string;
  formatBody?: ApiErrorOptions["formatBody"];
  className?: string;
}

export function FormErrorInline({
  error,
  fallback,
  formatBody,
  className,
}: FormErrorInlineProps) {
  if (!error) return null;
  const message = getApiErrorMessage(error, { fallback, formatBody });
  return (
    <div className={className ?? "admin-error"} role="alert">
      {message}
    </div>
  );
}
